import './modules/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import quiz from './modules/quiz';
import faqAccordion from './components/faq'
import appQuiz from './modules/app-quiz';
import blog from './components/blog';
import headerSearch from './components/search'

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
faqAccordion()
branchBar.init();
quiz.init();
appQuiz.init();
blog.init();
headerSearch.init()
